/**
     * @desc //12查询订单状态
用于：7,8,9,10,调用合约再调接口，然后调用该接口查询链上是否有处理结果，该接口最大执行时间7秒
     */

import * as defs from '../../baseClass';
import { PontCore } from '../../pontCore';
import * as ajax from '../../../utils/request';

export class Params {}

export const init = new defs.Result();

export function request(params, body, options = {}) {
  return ajax.post('/box/getOrderStatus', params);
}

export function upload(params, body, options = {}) {
  return ajax.upload('/box/getOrderStatus', params);
}
